import { LoaderFunction, redirect } from 'react-router-dom'

import type { Location } from '@/apiTypes.ts'
import { useAppointmentStore } from '@/store.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'

interface LoaderData {
  locations?: Location[]
  loadTime?: number
  error?: string
}

const loader: LoaderFunction<LoaderData> = async (): Promise<
  LoaderData | Response | null
> => {
  const {
    appointmentType,
    defaultLocationId,
    selectedLocation,
    setError,
    setSelectedLocation,
  } = useAppointmentStore.getState()

  if (!defaultLocationId || !appointmentType) {
    return {}
  }

  const startTime = Date.now()
  try {
    const response = await fetchFromApi(
      `locations?type=${appointmentType}&location=${defaultLocationId}`,
    )

    if (!response.ok) {
      throw new Error(`HTTP error status: ${response.status}`)
    }

    const locations: Location[] = await response.json()

    if (locations.length === 0) {
      setError('noLocations')
      return redirect('/error')
    }

    if (!selectedLocation) {
      const defaultLocation = locations.find(
        (location) => location.emmaId === defaultLocationId,
      )
      if (defaultLocation) {
        setSelectedLocation(defaultLocation)
      }
    }
    return { loadTime: Date.now() - startTime, locations }
  } catch (error) {
    console.error('Error fetching appointment slots:', error)
    return {
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    }
  }
}

export type { LoaderData }
export { loader }
